import { FormGroup, FormArray } from '@angular/forms';
export function onFormSubmit(form: FormGroup) {
    for (const key in form.controls) {
        const control = form.controls[key];
        control.markAsDirty();
        control.updateValueAndValidity();
        if (control instanceof FormArray) {
            for (const group of control.controls) {
                if (group instanceof FormGroup) {
                    onFormSubmit(group);
                }
            }
            continue;
        }
        const val = control.value;
        if (typeof val === "string") {
            const trimmed = val.trim();
            if (trimmed.length == 0) {
                control.setValue(null);
            }
            if (val.length > trimmed.length) {
                control.setValue(trimmed);
            }
        }
        control.updateValueAndValidity();
    }

}